module.exports = __webpack_public_path__ + "static/img/draw_rule.463dbb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/draw_rule.png
// module id = 562
// module chunks = 1